module.exports = "<div class=\"logo\">\n        <h4><a href=\"#\"><strong>Docfin Management Console</strong></a></h4>\n    </div>\n<nav id=\"sidebar\" class=\"sidebar nav-collapse collapse\">\n\t<ul id=\"side-nav\" class=\"side-nav\">\n\t<li *ngFor=\"let feature of featureList\" routerLinkActive=\"active\"\n\t\t\tclass=\"panel \"><a data-parent=\"#side-nav\" [routerLink]=\"[feature.routepath]\">\n\t\t\t<i class=\"{{feature.icon}}\"></i>\n\t\t\t <span class=\"name\">{{feature.description}}</span>\n\t\t</a>\n\t</li>\n\t\n\t</ul>\n</nav>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/navigation/navigation.component.html
// module id = 431
// module chunks = 1